export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.16-1327.29",
  commitId: "2d945b517f5038560ab0e07daf5dd05c1467894a",
  commitTime: "2026-04-16T13:27:29.000Z",
});
